export default __webpack_public_path__ + "static/microapps-02498181721f1e457bcf02c3192b411f.svg";